import React from 'react';
import HtmlParser from 'react-html-parser';
import { getLanguageObj, settings } from '../../helpers/UtilsHelper';
import Menu from '../main/Menu';
import { GlobalFormats } from '../../classes/main/globalFormatClass';

const currentMethod = 'Home - function';

const { app, company, icons, images, labels, tabs } = settings;
const { urls } = app?.backend;

export default function Privacy({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {

    const privacyItems = [
        app?.privacy?.paragraph02?.[languageObj?.id],
        app?.privacy?.paragraph03?.[languageObj?.id],
        app?.privacy?.paragraph04?.[languageObj?.id],
        app?.privacy?.paragraph05?.[languageObj?.id],
        app?.privacy?.paragraph06?.[languageObj?.id],
        app?.privacy?.paragraph07?.[languageObj?.id],
    ];

    return (
        <div>
            <Menu viewName={'home'} process={'privacy'} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Premium Bar) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-12 col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.privacy?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-12 col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href={urls?.home}>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.privacy?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='card border-0 shadow-lg login-card' >
                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                <div className='d-flex align-items-center justify-content-between'>
                                    <div className='d-flex align-items-center'>
                                        {/* Circular avatar container with dataProtection icon */}
                                        <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                            style={{
                                                width: '45px',
                                                height: '45px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                            <img alt='privacy'
                                                style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                src={images?.icons?.dataProtection} />
                                        </div>
                                        {/* Title & Badge */}
                                        <div className='d-flex flex-column'>
                                            <span className='h6 mb-0 font-weight-bold text-dark'>{labels?.privacy?.[languageObj?.id]}</span>
                                            <div className='mt-1'>
                                                <span className='badge badge-pill badge-primary px-2 py-1 text-uppercase'
                                                    style={settings?.html?.badges?.micro}>
                                                    <i className={`${icons?.fasFa?.userShield} mr-1`}></i> {labels?.privacy?.[languageObj?.id]}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Card Widget Tools */}
                                    <div className='card-tools'>
                                        <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                            <i className={icons?.fasFa?.minus} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className='card-body px-4 pb-4'>
                                <div className='row'>
                                    <div className='col-lg-12'>
                                        {/* Introductory Paragraph */}
                                        <p className='text-muted mb-4' style={{ fontSize: '15px', lineHeight: '1.6', textIndent: '4em' }}>
                                            {HtmlParser(`${tabs?.four} ${app?.privacy?.paragraph01?.[languageObj?.id]}`)}
                                        </p>

                                        {/* Policies List Group */}
                                        <div className='list-group list-group-flush mb-4'>
                                            {privacyItems.map((item, idx) => (
                                                <div key={idx} className='list-group-item bg-transparent border-0 px-0 py-3 d-flex align-items-start'>
                                                    <div className='mr-3 mt-1'>
                                                        <span className='badge badge-pill badge-primary d-flex align-items-center justify-content-center shadow-sm'
                                                            style={{ width: '28px', height: '28px', fontSize: '14px', fontWeight: 'bold' }}>
                                                            {idx + 1}
                                                        </span>
                                                    </div>
                                                    <div className='flex-grow-1 text-secondary' style={{ fontSize: '15px', lineHeight: '1.6' }}>
                                                        {HtmlParser(item)}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        <hr className='my-4' />

                                        {/* Closing & Signature */}
                                        <div className='mt-4 d-flex flex-column align-items-start'>
                                            <p className='text-muted font-italic mb-3' style={{ fontSize: '15px' }}>
                                                {labels?.sincerely?.[languageObj?.id]}
                                            </p>
                                            <div className='d-flex align-items-center flex-wrap'>
                                                <img src={images?.logoCHEJ} alt='LogoCompany' style={{ width: '100px', height: 'auto', marginRight: '20px', objectFit: 'contain' }} />
                                                <div className='d-flex flex-column mt-2 mt-sm-0'>
                                                    <span className='font-weight-bold text-dark' style={{ fontSize: '16px' }}>{company?.name}</span>
                                                    <span className='text-muted' style={{ fontSize: '13px' }}>{company?.slogan}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
            </div>
        </div>
    )
}